/**
 * Conversation-list preview text.
 *
 * Pure and free of server dependencies, so the route stays a thin caller and
 * the rule itself is directly testable.
 */

import { isMarkdownChannel } from './channels/channel-text-format'
import { stripMarkdown } from '@/lib/markdown'

const PREVIEW_MAX_LENGTH = 100

export interface PreviewSourceMessage {
  content_text: string | null
  direction: string
}

/**
 * A reply we authored on a Markdown-format channel is flattened so the list
 * does not show raw `[text](url)`; everything else — inbound visitor text, and
 * every plain channel including WhatsApp's native markers — is shown as stored.
 * Flatten before slicing: a cut through `](` leaves worse noise than it removes.
 */
export function buildConversationPreview(
  lastMessage: PreviewSourceMessage | undefined,
  channelType: string,
): string | null {
  const text = lastMessage?.content_text
  if (!text) return null

  const shown =
    isMarkdownChannel(channelType) && lastMessage.direction === 'outbound'
      ? stripMarkdown(text)
      : text

  return shown.slice(0, PREVIEW_MAX_LENGTH)
}
